import NormalText from "./NormalText";

const Price = (props) => {
  const price = props.price;

  return (
    <div>
      <NormalText text={formatter.format(price)}></NormalText>
    </div>
  );
};

export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",

  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const CurrencyCovertor = (coverValue, coverinfo = null, convertToPercent=true) => {
  let returnValue = "";

  if (!coverValue) return null;

  if (isNaN(coverValue)) {
    returnValue = coverValue + "";
  } else {
    if (coverValue > 0 && coverValue <= 2 && convertToPercent) {
      returnValue = coverValue * 100 + "%";
    } else {
      returnValue = formatter.format(coverValue);
    }
  }

  if(coverinfo && coverinfo?.inputvaluetype && ['percent', 'percent2f'].includes(coverinfo?.inputvaluetype) && coverValue > 2 ){
    returnValue = coverValue + "%"
  }

  if(coverinfo?.otherinfo?.forceString){
    returnValue = coverValue;
  }
  if(false){
    console.log(returnValue)
  }

  return returnValue;
};

export const DisplayCoverValue = (coverValue, coverinfo = null, convertToPercent=true) => {
  let returnValue = "";
  if (!coverValue) return null;

  if (isNaN(coverValue)) {
    returnValue = coverValue + "";
  } else {
    if (coverinfo.inputvaluetype == 'number'){
      returnValue = coverValue
    }
    else if (coverValue > 0 && coverValue <= 2 && convertToPercent) {
      returnValue = coverValue * 100 + "%";
    } 
    else if (coverinfo.inputvaluetype == 'currency'){
      returnValue = formatter.format(coverValue);
    }
    else {
      returnValue = formatter.format(coverValue);
    }
  }

  if(coverinfo && coverinfo?.inputvaluetype && ['percent', 'percent2f'].includes(coverinfo?.inputvaluetype) && coverValue > 2 ){
    returnValue = coverValue + "%"
  }

  if(coverinfo?.otherinfo?.forceString){
    returnValue = coverValue;
  }
  if(false){
    console.log(returnValue)
  }

  return returnValue;
};

export default Price;
